export const navTitles = ['Home', 'About Us', 'Events', 'Projects', /* 'Articles', */ 'Contact Us']
